import scrollLock from 'scroll-lock';
import { gsap } from 'gsap';
import barba from '@barba/core';

export default class Scrolllocking {
	constructor() {
		this.shouldLock = false;

		document.addEventListener('disable-scroll', event => {
			let scrollingElm = null;
			if(event.detail) {
				scrollingElm = event.detail.scrollingElm;
			}
			this.lock(scrollingElm);
		});

		document.addEventListener('enable-scroll', () => {
			this.unlock();
		});

		this.setScrollbarWidth();
	}

	setScrollbarWidth() {
		const scrollbarWidth = scrollLock.getPageScrollBarWidth();
		document.documentElement.style.setProperty('--scrollbarWidth', scrollbarWidth+'px');
	}

	lock(scrollingElm) {
        scrollLock.disablePageScroll(scrollingElm);
	}

	unlock() {
		const namespace = barba.C.next.namespace;
		if(namespace==='template-work'||namespace==='template-features') {
			// Unlock override
		} else {
			scrollLock.clearQueueScrollLocks();
			scrollLock.enablePageScroll();
		}
	}

}